export const MICRODEGREES = [
  {
    title: 'MICRODEGREE_PRODUCT_MANAGEMENT',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-46b3488a-af0c-480c-942d-10f71909fdaf-pm.jpg?auto=format',
    url: '/microdegree/product-management/',
  },
  {
    title: 'MICRODEGREE_MARKETING',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-20d27ab3-c21b-4e0a-8193-0d1679c37b19-mkt.jpg?auto=format',
    url: '/microdegree/marketing-digital/',
  },
  {
    title: 'MICRODEGREE_UXUI',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-47788fab-52ad-4b2e-ae9e-e683e6511b07-uxui.jpg?auto=format',
    url: '/microdegree/ux-ui/',
  },
  {
    title: 'MICRODEGREE_DATA',
    image:
      'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/automated-v2-45bd7d70-fc68-4aa2-9c44-24dc82759426-data.jpg?auto=format',
    url: '/microdegree/data-analytics/',
  },
];
